import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFAutocomplete, RHFTextField } from 'src/components/hook-form';
import { getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { formatDate, handleErrorMessages } from '../../risk-register/feching';
import Iconify from 'src/components/iconify';
import { DatePicker } from '@mui/x-date-pickers';
import { MultiFilePreview, Upload } from 'src/components/upload';

const BankConcilationCreate = ({ open, onClose, currentItem, closeform, onFormSuccess }) => {
    console.log("🚀 ~ BankConcilationCreate ~ currentItem:", currentItem)
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [riskIds, setRiskIds] = useState([]);
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [isFileDeleted, setIsFileDeleted] = useState(false);
    const [filePreview, setFilePreview] = useState([]);
    const NewUserSchema = Yup.object().shape({

    });


    const defaultValues = useMemo(
        () => ({

        }),
        []
    );
    const methods = useForm({
        resolver: yupResolver(NewUserSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [currentItem, reset, defaultValues]);


    useEffect(() => {
        console.log("🚀 ~ defaultValues------:", defaultValues)
        if (currentItem) {
            if (currentItem.file != null) {
                setFilePreview([{ ...currentItem.file, preview: currentItem.file.url }]);
            } else {
                setFilePreview([]);
            }
        }
    }, [defaultValues]);


    // Handle form submission
    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('start_date', formatDate(data?.start_date));
        formData.append('end_date', formatDate(data?.end_date));
        if (isFileDeleted) {
            formData.append('is_file_deleted', true);
        }
        if (files.length > 0) {
            formData.append('bank_statement', files[0]);
        }
        try {
            const response = await postRequest(endpoints.accounting.bankReconcilation.post_list, formData, true);
            if (response.metadata && response.metadata.success) {
                reset();
                onClose();
                setFiles([])
                //closeform();
                //reload();
                onFormSuccess(response.payload); // Pass response data to update table
                enqueueSnackbar({ variant: 'success', message: response.metadata.message });
            } else {
                handleErrorMessages(response?.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });



    const handleDrop = useCallback(
        (acceptedFiles) => {
            const newFiles = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                }));
            setFiles([...newFiles]);
        },
        [files]
    );



    const handleClose = () => {
        console.log("close clicked----");
        setIsFileDeleted(false);
        onClose(); // Close the dialog
    };

    const handleRemoveFile = (inputFile) => {
        setIsFileDeleted(true);
        setFiles([]);
        setFilePreview([]);
    };


    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            }}
            fullWidth
            maxWidth="md"
            sx={{
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            }}
            transitionDuration={{
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            }}
        >
            <FormProvider methods={methods} onSubmit={onSubmit}>

                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxSizing: 'content-box' }}>
                    <span
                        className='cardColor'
                        style={{ padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' }}>
                        &nbsp;&nbsp;  Bank Reconcilation  &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={onClose}>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent
                    sx={{
                        borderRadius: '1px',
                    }}
                >
                    <Box
                        mt={2}
                        rowGap={3}
                        columnGap={2}
                        display="grid"
                        gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                            sm: 'repeat(2, 1fr)',
                        }}
                    >
                        <Controller
                            name="start_date"
                            render={({ field, fieldState: { error } }) => (
                                <DatePicker
                                    label="Start Date"
                                    {...field}
                                    inputFormat="yyyy-MM-dd"
                                    //disableFuture
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            error={!!error}
                                            helperText={error?.message}
                                        />
                                    )}
                                />
                            )}
                        />
                        <Controller
                            name="end_date"
                            render={({ field, fieldState: { error } }) => (
                                <DatePicker
                                    label="End Date"
                                    {...field}
                                    inputFormat="yyyy-MM-dd"
                                    //disableFuture
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            error={!!error}
                                            helperText={error?.message}
                                        />
                                    )}
                                />
                            )}
                        />



                    </Box>
                    <Box
                        mt={4}
                        rowGap={3}
                        display="grid"
                        gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                        }}
                    >
                        {/*<Typography variant="subtitle2">Related Documents</Typography>*/}
                        <Upload onDrop={handleDrop} onRemove={handleRemoveFile} />

                    </Box>
                    <Box sx={{ my: 3 }}>
                        <MultiFilePreview
                            files={files?.length > 0 ? files : filePreview}
                            onRemove={handleRemoveFile}
                            setFileDeleted={setIsFileDeleted}
                        />
                        {/*<RHFTextField name="request_id" label="Sr No" />
                        <Controller
                            name="escalation_date"
                            // control={control}
                            render={({ field, fieldState: { error } }) => (
                                <DatePicker
                                    label="Transaction  Date"
                                    {...field}
                                    inputFormat="yyyy-MM-dd"
                                    disableFuture
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            error={!!error}
                                            helperText={error?.message}
                                        />
                                    )}
                                />
                            )}
                        />
                        <RHFAutocomplete
                            name="approval_status"
                            label="Bank Account"
                            options={['cehcking', 'saving', 'credit card', 'loan', 'other']}
                            getOptionLabel={(option) => option}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option) => <li {...props} key={option}>{option}</li>}
                            error={!!methods.formState.errors.approval_status}
                            helperText={methods.formState.errors.approval_status?.message}
                        />
                        
                        <RHFAutocomplete
                            name="approval_status"
                            label="General Ledger Account"
                            options={['cehcking', 'saving', 'credit card', 'loan', 'other']}
                            getOptionLabel={(option) => option}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option) => <li {...props} key={option}>{option}</li>}
                            error={!!methods.formState.errors.approval_status}
                            helperText={methods.formState.errors.approval_status?.message}
                        />
                        
                        <RHFTextField name="requested_changes" label="Debit" />
                        <RHFTextField name="requested_changes" label="Credit" />
                        <RHFTextField name="requested_changes" label="ledger Amount" />
                        <RHFTextField name="reason_for_change" label="Difference" />
                        <RHFTextField name="requested_by" label="Status" />*/}

                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={onClose}>
                        Cancel
                    </Button>
                    <LoadingButton type="submit" variant="contained" className='dark-button'
                        loading={isSubmitting}>
                        {!currentItem || !currentItem.id ? 'Create ' : 'Update '}
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog>
    );
};
export default BankConcilationCreate;